/**
 * Quantato: The Outlier
 * Main entry point - Game configuration with dual physics
 */

import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';
import Phaser from 'phaser';
import { CONSTANTS } from './config.js';

inject();
injectSpeedInsights();
import { BootScene } from './scenes/BootScene.js';
import { TitleScene } from './scenes/TitleScene.js';
import { HoneypotScene } from './scenes/HoneypotScene.js';
import { TransitionScene } from './scenes/TransitionScene.js';
import { GameplayScene } from './scenes/GameplayScene.js';
import { GameOverScene } from './scenes/GameOverScene.js';
import { VictoryScene } from './scenes/VictoryScene.js';

const config = {
    type: Phaser.WEBGL,
    width: CONSTANTS.WIDTH,
    height: CONSTANTS.HEIGHT,
    parent: 'game-container',
    backgroundColor: CONSTANTS.COLORS.BRIGHT_BG,
    scale: {
        mode: Phaser.Scale.EXPAND,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        min: {
            width: 320,
            height: 240
        },
        max: {
            width: 1600,
            height: 1200
        }
    },
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
            debug: false
        },
        matter: {
            gravity: { y: 1 },
            debug: false,
            enableSleeping: true
        }
    },
    scene: [
        BootScene,
        TitleScene,
        HoneypotScene,
        TransitionScene,
        GameplayScene,
        GameOverScene,
        VictoryScene
    ],
    render: {
        pixelArt: false,
        antialias: true,
        antialiasGL: true
    },
    input: {
        activePointers: 3 // Support multi-touch
    }
};

// Handle visibility change to pause/resume
document.addEventListener('visibilitychange', () => {
    if (window.game) {
        if (document.hidden) {
            window.game.scene.scenes.forEach(scene => {
                if (scene.scene.isActive()) {
                    scene.scene.pause();
                }
            });
        } else {
            window.game.scene.scenes.forEach(scene => {
                if (scene.scene.isPaused()) {
                    scene.scene.resume();
                }
            });
        }
    }
});

// Create game instance
window.game = new Phaser.Game(config);
